<div [formGroup]="form">
    <div class="form-group">
        <label for="accountOwner">{{ 'CORE.PAYMENT.HOLDER' | translate }}</label>
        <input type="text" class="form-control" id="accountOwner" placeholder="{{ 'CORE.PAYMENT.HOLDER' | translate }}" formControlName="accountOwner" />
    </div>
    <div class="form-group row">
        <div class="col-9">
            <div class="form-group">
                <label for="iban">{{ 'CORE.PAYMENT.IBAN' | translate }}</label>
                <input type="text" class="form-control" id="iban" placeholder="{{ 'CORE.PAYMENT.IBAN' | translate }}" formControlName="iban" />
            </div>
        </div>
        <div class="col-3">
            <div class="form-group">
                <label for="bic">{{ 'CORE.PAYMENT.BIC' | translate }}</label>
                <input type="number" min="1" class="form-control" id="bic" placeholder="{{ 'CORE.PAYMENT.BIC' | translate }}" formControlName="bic" />
            </div>
        </div>
    </div>
    <div class="horizontal-divider-dashed mt-2 mb-4"></div>
    <span class="mb-3">
        <i class="pi pi-info-circle" style="font-size: 13px"></i>
        {{ 'USERMANAGEMENT.SEPA_MANDAT_INFO' | translate }}
    </span>
    <div class="form-group">
        <label for="sepaMandate">{{ 'CORE.PAYMENT.SEPA_MANDAT' | translate }}</label>
        <input type="text" class="form-control" id="sepaMandate" placeholder="{{ 'CORE.PAYMENT.SEPA_MANDAT' | translate }}" formControlName="sepaMandate" />
    </div>
</div>
